import React, {
  useEffect,
  useRef,
  useState,
  Dispatch,
  SetStateAction,
  Suspense,
} from 'react';
import {
  Button,
  Icon,
  Input,
  Pagination,
  Select,
  Table,
} from 'semantic-ui-react';
import { CSVLink } from 'react-csv';
import { useParams } from 'react-router';
import { useStore } from '../../../app/stores/store';
import DeleteModal from '../../../library/deleteModal';
import agent from '../../../app/api/agent';
import CarouselLib from '../../../library/carousel';
import './styles.css';
import { Link } from 'react-router-dom';
import {
  static_items_id,
  static_worklevel_id,
} from '../../DashboardConfiguration/settings/constants';
import { useNavigate } from 'react-router-dom';
import DeleteConfirmation from '../../../app/common/modals/DeleteConfirmation';

const FormRegister = React.lazy(() => import('../../newMaster/FormRegister'));

type masterElementType = {
  elementId: string;
  elementName: string;
  mode: number | undefined;
  criteria?: { type: string; value: string }[] | undefined;
  editAndDelete?:
    | { metadata: string; comparison: string; value: string }[]
    | undefined;
};

function TableReport({
  style,
  rowSelectedId,
  rowClickHandler,
  name,
  masterId,
  // isMaster,
  masterName,
  assetType,
  elementType,
  isTableUpdated,
  setIsTableUpdated,
  metaData = [],
  downloadBtnMode,
  deleteBtnMode,
  editBtnMode,
  automaticPdf = false,
}: {
  style?: any;
  rowSelectedId?: string;
  rowClickHandler?: (data: any) => void;
  name?: string;
  masterName?: string;
  masterId?: string;
  assetType?: string;
  elementType?: string;
  index?: number;
  isTableUpdated?: boolean;
  isMaster?: boolean;
  setIsTableUpdated?: Dispatch<SetStateAction<boolean>>;
  flexBasis?: string;
  metaData: masterElementType[];
  downloadBtnMode: number;
  deleteBtnMode: number;
  editBtnMode: number;
  automaticPdf: boolean;
}) {
  const {
    modalStore,
    DynamicDashboardStore,
    commonStore,
    userStore,
    dashboardStore,
    activityStore,
  } = useStore();

  const { id } = useParams<{ id: string }>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openItemDeleteModal, setOpenItemDeleteModal] = useState<{
    id: string;
    name: string;
  }>({ id: '', name: '' });
  const [isCarouselModalOpen, setIsCarouselModalOpen] = useState(false);
  const [tableDetails, setTableDetails] = useState<any[]>([]);
  const [tableHeaderDetails, setTableHeaderDetails] = useState<any[]>([]);
  const [searchDetails, setSearchDetails] = useState<any>({});
  const [activePage, setActivePage] = useState<number>(1);
  const [count, setCount] = useState<number>(0);
  const [tableName, setTableName] = useState<string>('');
  const [photos, setPhotos] = useState<string[]>([]);
  const [loader, setLoader] = useState({
    content: false,
    submit: false,
  });
  const [deleteDetails, setDeleteDetails] = useState({
    loading: false,
    assetId: '',
  });
  const [isCriteria, setIsCriteria] = useState(false);
  const [pageSize] = useState(10);
  const [itemsPayload] = useState<string[]>(
    metaData?.filter((d) => d.mode !== 2).map((fd) => fd.elementName),
  );
  const [itemsSearchList, setItemsSearchList] = useState<any>([]);

  const history = useNavigate();

  const sortedNames = useRef<{
    [key: string]: string;
  }>({});
  const tableCopyRef = useRef<any[]>([]);

  useEffect(() => {
    dashboardStore.updateCountOrderMenu(userStore.user?.id);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (masterId === static_items_id) {
      const temp: any = [];
      itemsPayload?.forEach(async (i: any) => {
        const response = await activityStore?.inventorySearchList(i);
        temp[i] = [];
        temp[i] = response?.map((r: string) => {
          return {
            key: r,
            text: r,
            value: r,
          };
        });
      });
      setItemsSearchList(temp);
    }
    // eslint-disable-next-line
  }, [masterId, itemsPayload]);

  function getDataGrid(pageNumber?: number) {
    setLoader((p) => ({
      ...p,
      content: true,
    }));
    (async () => {
      try {
        if (masterId === static_items_id) {
          let search =
            Object.keys(searchDetails)?.length > 0 ? searchDetails : null;
          if (assetType) {
            if (search === null) {
              search = {};
            }
            // search['type'] = getAssetName(assetType);
            search['type'] = assetType;
          }
          if (elementType) {
            if (search === null && assetType === undefined) {
              search = {};
            }
            // search['element'] = getElementName(elementType);
            search['element'] = elementType;
          }

          const temp = [...itemsPayload];
          if (!itemsPayload.includes('Title')) {
            temp.unshift('Title');
          }
          if (!itemsPayload.includes('Id')) {
            temp.unshift('Id');
          }
          let params = {
            searchData: search,
            pageNo: pageNumber || activePage,
            pageSize: pageSize,
          };

          let [fResult, countResult] = await Promise.all([
            await agent.assetList.getItemsList(temp, params),
            await agent.Activities.inventoryCount(
              activityStore.enocoded_Uri_Data(params.searchData),
            ),
          ]);
          if (fResult !== undefined) {
            // if(typeof fResult?.data !== 'string' && fResult?.data?.length === 0) {
            //   setTableHeaderDetails(itemsPayload);
            //   setTableDetails(fResult?.data);
            // } else {
            // let replacedData = fResult?.data
            // ?.replaceAll('&#x0022;', '"')
            // ?.replaceAll('&#x005D;', ']')
            // ?.replaceAll('&#x005B;', '[')
            // ?.replaceAll('0xFE5B', '{')
            // ?.replaceAll('0xFE5C', '}')
            // ?.replaceAll('U+003B', ';')
            // ?.replaceAll('U+006E', '')
            // ?.replaceAll('U+003A', ':')
            // ?.replaceAll(',}}', '}')
            // ?.replaceAll('}}', '}');
            // let parseData = JSON.parse(replacedData || '[]');
            // let tableKeys = Object.keys(fResult?.data[0]);
            // if (!itemsPayload.includes('Id')) {
            //   tableKeys = tableKeys.filter((header: string) => header !== 'Id');
            // }
            // if (!itemsPayload.includes('Title')) {
            //   tableKeys = tableKeys.filter(
            //     (header: string) => header !== 'Title',
            //   );
            // }
            //   $(document).ready(function () {
            //     var originalJSON = {
            //         "name": "John",
            //         "age": 30,
            //         "city": "New York"
            //     };
            //    var keyOrder = ["city", "name", "age"];
            //    var reorderedJSON = {};
            //     $.each(keyOrder, function (index, key) {
            //         if (originalJSON.hasOwnProperty(key)) {
            //             reorderedJSON[key] = originalJSON[key];
            //         }
            //     });
            //    console.log(reorderedJSON);
            // });
            let tableKeys = [...itemsPayload];
            tableKeys?.unshift('assetId');
            let tempTableData: any[] = [];
            if (tableKeys.length === 1) {
              // tableKeys?.push('Id');
              tableKeys?.push('Title');
            }
            setTableHeaderDetails(tableKeys);
            let reorderedJSON: any = {};
            fResult?.data?.forEach((dt: any) => {
              reorderedJSON = {};
              temp?.forEach((k: string) => {
                if (dt.hasOwnProperty(k)) {
                  reorderedJSON[k] = dt[k];
                }
              });
              tempTableData?.push(reorderedJSON);
            });
            setTableDetails(tempTableData);
            // }
          }
          if (countResult !== undefined) {
            setCount(countResult);
          }
        } else {
          const isCriteria = metaData?.filter(
            (data) => data.criteria !== undefined,
          );
          if (isCriteria.length === 0) {
            setIsCriteria(false);
            let search =
              Object.keys(searchDetails)?.length > 0 ? JSON.stringify(searchDetails) : null;
            let [fResult, countResult, SResult] = await Promise.all([
              agent.newMasterReport.getAllMasterReports({
                masterId: id || masterId || '',
                searchData: search || "",
                PageNumber: pageNumber || activePage || 1,
                PageSize: pageSize,
              }),
              agent.newMasterReport.getMasterReportsCount({
                masterId: id || masterId || '',
                searchData: search || '',
              }),
              agent.newMasterReport.getMasterName({
                masterId: id || masterId || '',
              }),
            ]);
            if (SResult.data) {
              setTableName(SResult.data);
            }
            if (countResult?.data) {
              setCount(countResult?.data);
            }
            if (fResult?.data) {
              let parseData = JSON.parse(fResult.data);
              if (metaData.length === 0) {
                if (masterId !== static_worklevel_id) {
                  parseData?.header.pop();
                  parseData?.header.unshift('assetId');
                }
                setTableHeaderDetails(parseData?.header);
                setTableDetails(parseData?.list);
              } else {
                const payload = {
                  masterId: id || masterId || '',
                  ids:
                    metaData
                      ?.filter((data) => data.mode !== 2)
                      .map((meta) => meta.elementId) || [],
                };
                let metaDataResult =
                  await agent.newMasterReport.getMasterMetaDataBasedOnID(
                    payload,
                  );
                let metaDataIDs = metaDataResult?.data?.map(
                  (data: any) => data.elementId,
                );
                metaData = metaData?.filter(
                  (data) => metaDataIDs?.includes(data.elementId),
                );
                let expectedHeaders: any = [
                  {
                    name: 'assetId',
                    mode: 1,
                    criteria: undefined,
                    editAndDelete: undefined,
                  },
                ];
                metaData?.forEach((data) => {
                  // return {
                  //   name: data.elementName,
                  //   mode: data.mode,
                  //   criteria: data.criteria,
                  // };
                  expectedHeaders.push({
                    name: data.elementName,
                    mode: data.mode || 1,
                    criteria: data.criteria,
                    editAndDelete: data.editAndDelete,
                  });
                });
                // expectedHeaders.push({
                //   name: 'assetId',
                //   mode: 1,
                //   criteria: undefined,
                // });
                expectedHeaders = expectedHeaders?.filter(
                  (headers: any) => headers.mode !== 2,
                );
                let expectedHeadersNames = expectedHeaders?.flatMap(
                  (data: any) => data.name || data,
                );
                let expectedColumns = parseData?.list?.map((data: any) => {
                  let keys = Object.keys(data);
                  keys?.forEach((k: string) => {
                    if (!expectedHeadersNames?.includes(k)) {
                      if (k !== 'assetId') {
                        delete data[k];
                      }
                    }
                  });
                  return data;
                });

                setTableHeaderDetails(expectedHeaders);
                setTableDetails(expectedColumns);
                // demo login
                if (
                  DynamicDashboardStore.staticSelectedCard === 'Create Client'
                ) {
                  setTableDetails(expectedColumns);
                } else if (
                  DynamicDashboardStore.staticSelectedCard === 'Project'
                ) {
                  setTableDetails(expectedColumns);
                } else if (
                  DynamicDashboardStore.staticSelectedCard.includes('Signed WO')
                ) {
                  const tempTableDetails = expectedColumns?.filter(
                    (data: any) =>
                      (data['WO Signed'] === '' ||
                        data['WO Signed'] === null) &&
                      data['Agreement Signed'] === 'Yes',
                  );
                  setTableDetails(tempTableDetails);
                  setCount(tempTableDetails.length);
                } else if (
                  DynamicDashboardStore.staticSelectedCard ===
                  'Advance Received'
                ) {
                  const tempTableDetails = expectedColumns?.filter(
                    (data: any) =>
                      (data['Advance Received'] === '' ||
                        data['Advance Received'] === null) &&
                      data['WO Signed'] === 'Yes',
                  );
                  setTableDetails(tempTableDetails);
                  setCount(tempTableDetails.length);
                } else if (
                  DynamicDashboardStore.staticSelectedCard ===
                  'Special Approval'
                ) {
                  const tempTableDetails = expectedColumns?.filter(
                    (data: any) => data['Approved'] !== 'Yes',
                  );
                  expectedColumns?.filter((data: any) =>
                    data['Approved'] !== 'Yes' && data['Approved By'] === ''
                      ? commonStore.DemoChangesforApprovedCard
                      : '',
                  );
                  setTableDetails(tempTableDetails);
                  setCount(tempTableDetails.length);
                }
              }
            }
          } else {
            setIsCriteria(true);
            let search =
              Object.keys(searchDetails)?.length > 0 ? JSON.stringify(searchDetails) : null;
            let [countResult, SResult] = await Promise.all([
              agent.newMasterReport.getMasterReportsCount({
                masterId: id || masterId || '',
                searchData: search || '',
              }),
              agent.newMasterReport.getMasterName({
                masterId: id || masterId || '',
              }),
            ]);
            if (SResult.data) {
              setTableName(SResult.data);
            }
            let fResult;
            const totalCount =
              Math.ceil(countResult?.data / pageSize) * pageSize || 5;
            fResult = await agent.newMasterReport.getAllMasterReports({
              masterId: id || masterId || '',
              searchData: search || '',
              PageNumber: 1 || activePage,
              PageSize: totalCount,
            });

            if (fResult?.data) {
              let parseData = JSON.parse(fResult.data);
              const payload = {
                masterId: id || masterId || '',
                ids:
                  metaData
                    ?.filter((data) => data.mode !== 2)
                    .map((meta) => meta.elementId) || [],
              };
              let metaDataResult =
                await agent.newMasterReport.getMasterMetaDataBasedOnID(payload);
              let metaDataIDs = metaDataResult?.data?.map(
                (data: any) => data.elementId,
              );
              metaData = metaData?.filter(
                (data) => metaDataIDs?.includes(data.elementId),
              );
              let expectedHeaders: any = [
                {
                  name: 'assetId',
                  mode: 1,
                  criteria: undefined,
                  editAndDelete: undefined,
                },
              ];
              metaData?.forEach((data) => {
                // return {
                //   name: data.elementName,
                //   mode: data.mode,
                //   criteria: data.criteria,
                // };
                expectedHeaders.push({
                  name: data.elementName,
                  mode: data.mode || 1,
                  criteria: data.criteria,
                  editAndDelete: data.editAndDelete,
                });
              });
              // expectedHeaders.push({
              //   name: 'assetId',
              //   mode: 1,
              //   criteria: undefined,
              // });
              expectedHeaders = expectedHeaders?.filter(
                (headers: any) => headers.mode !== 2,
              );
              let expectedHeadersNames = expectedHeaders?.flatMap(
                (data: any) => data.name || data,
              );
              let expectedColumns = parseData?.list?.map((data: any) => {
                let keys = Object.keys(data);
                keys?.forEach((k: string) => {
                  if (!expectedHeadersNames?.includes(k)) {
                    if (k !== 'assetId') {
                      delete data[k];
                    }
                  }
                });
                return data;
              });
              setTableHeaderDetails(expectedHeaders);
              expectedHeaders?.forEach((header: any) => {
                if (header?.criteria) {
                  for (let i = 0; i < header.criteria?.length; i++) {
                    switch (header.criteria[i].type) {
                      case 'equals':
                        expectedColumns = expectedColumns?.filter(
                          (data: any) =>
                            header.criteria !== undefined &&
                            data[`${header.name}`] ===
                              `${header.criteria[i].value}`,
                        );
                        break;
                      case 'not equals':
                        expectedColumns = expectedColumns?.filter(
                          (data: any) =>
                            header.criteria !== undefined &&
                            data[`${header.name}`] !==
                              `${header.criteria[i].value}`,
                        );
                        break;
                      case 'greater than':
                        expectedColumns = expectedColumns?.filter(
                          (data: any) =>
                            header.criteria !== undefined &&
                            data[`${header.name}`] >
                              `${header.criteria[i].value}`,
                        );
                        break;
                      case 'less than':
                        expectedColumns = expectedColumns?.filter(
                          (data: any) =>
                            header.criteria !== undefined &&
                            data[`${header.name}`] <
                              `${header.criteria[i].value}`,
                        );
                        break;
                      case 'greater than or equal to':
                        expectedColumns = expectedColumns?.filter(
                          (data: any) =>
                            header.criteria !== undefined &&
                            data[`${header.name}`] >=
                              `${header.criteria[i].value}`,
                        );
                        break;
                      case 'less than or equal to':
                        expectedColumns = expectedColumns?.filter(
                          (data: any) =>
                            header.criteria !== undefined &&
                            data[`${header.name}`] <=
                              `${header.criteria[i].value}`,
                        );
                        break;
                      default:
                        return;
                    }
                  }
                }
              });
              setTableDetails(expectedColumns);
              setCount(expectedColumns.length);
            }
          }
        }
        setLoader((p) => ({
          ...p,
          content: false,
        }));
      } catch {
        setLoader((p) => ({
          ...p,
          content: false,
        }));
      }
    })();
    setIsTableUpdated?.(false);
  }

  useEffect(() => {
    let timer = setTimeout(() => {
      getDataGrid(1);
      setActivePage(1);
    }, 700);

    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [searchDetails]);

  useEffect(() => {
    getDataGrid();
    // eslint-disable-next-line
  }, [name, DynamicDashboardStore.staticSelectedCard, id]);

  useEffect(() => {
    tableCopyRef.current = JSON.parse(JSON.stringify(tableDetails));
  }, [tableDetails]);

  useEffect(() => {
    if (isTableUpdated) getDataGrid();
    // eslint-disable-next-line
  }, [isTableUpdated]);

  const editHandler = (assetId: string, itemId: string) => {
    if (masterId === static_items_id) {
      history(`/manage/${itemId}`);
    } else {
      modalStore.modal.open = true;
      modalStore.modal.body = (
        <Suspense fallback={<></>}>
          <FormRegister
            masterId={masterId}
            masterName={tableName}
            isEdit
            assetId={assetId}
            afterSavedHandler={getDataGrid}
            metaData={metaData}
            automaticPdf={automaticPdf}
            setIsTableUpdated={setIsTableUpdated}
            dataGridName={name}
          />
        </Suspense>
      );
    }
  };

  const deleteHandler = async () => {
    setDeleteDetails({
      ...deleteDetails,
      loading: true,
    });

    await agent.newMasterReport.deleteMasterAsset({
      assetId: deleteDetails.assetId,
    });

    let filter = tableDetails?.filter(
      (d) => d.assetId !== deleteDetails.assetId,
    );
    setTableDetails(filter);
    setIsModalOpen(false);
    setDeleteDetails({
      assetId: '',
      loading: false,
    });
    setIsTableUpdated?.(true);
    // }
  };

  const refreshHandler = () => {
    getDataGrid();
  };

  const tableDownloadHandler = () => {
    return tableCopyRef.current?.map((d: { assetId?: string }) => {
      delete d.assetId;
      return d;
    });
  };

  const onPageChangeHandler = (_e: any, data: any) => {
    setActivePage(data.activePage);
    getDataGrid(data.activePage);
  };

  const HandleEditAndDelete = (expectedColumns: any) => {
    if (!expectedColumns || typeof expectedColumns !== 'object') {
      // Handle the case when expectedColumns is not provided, is undefined, or not an object.
      return false;
    }
    let passedFilter = true;

    tableHeaderDetails?.forEach((header: any) => {
      if (!header.hasOwnProperty('editAndDelete')) {
        passedFilter = true;
      }
      if (header?.editAndDelete) {
        for (const key in expectedColumns) {
          if (Object.hasOwnProperty.call(expectedColumns, key)) {
            if (header?.editAndDelete?.metadata === key) {
              const data = expectedColumns[key];
              switch (header.editAndDelete.comparison) {
                case 'equals':
                  if (
                    header.editAndDelete.value !== undefined &&
                    data === header.editAndDelete.value
                  ) {
                    passedFilter = false;
                    break; // Break the loop when a match is found
                  } else passedFilter = true;
                  break;
                case 'not equals':
                  if (
                    header.editAndDelete.value !== undefined &&
                    data !== header.editAndDelete.value
                  ) {
                    passedFilter = false;
                    break; // Break the loop when a match is found
                  } else passedFilter = true;
                  break;
                case 'greater than':
                  if (
                    header.editAndDelete.value !== undefined &&
                    data > header.editAndDelete.value
                  ) {
                    passedFilter = false;
                    break; // Break the loop when a match is found
                  } else passedFilter = true;
                  break;
                case 'less than':
                  if (
                    header.editAndDelete.value !== undefined &&
                    data < header.editAndDelete.value
                  ) {
                    passedFilter = false;
                    break; // Break the loop when a match is found
                  } else passedFilter = true;
                  break;
                case 'greater than or equal to':
                  if (
                    header.editAndDelete.value !== undefined &&
                    data >= header.editAndDelete.value
                  ) {
                    passedFilter = false;
                    break; // Break the loop when a match is found
                  } else passedFilter = true;
                  break;
                case 'less than or equal to':
                  if (
                    header.editAndDelete.value !== undefined &&
                    data <= header.editAndDelete.value
                  ) {
                    passedFilter = false;
                    break; // Break the loop when a match is found
                  } else passedFilter = true;
                  break;
                // Add other cases as needed.
              }
            }
          }
        }
      }
    });

    return passedFilter;
  };

  const displayGridData = (data: any, disable: boolean) => {
    const stringData = data.split('DynamicTable|')?.[1].replaceAll("'", '"');
    let tempValue = stringData !== undefined ? JSON.parse(stringData) : [];
    let columnHeaders: string[] = [];
    if (tempValue[0]) {
      columnHeaders = Object.keys(tempValue[0]);
      columnHeaders = columnHeaders?.filter((data) => data !== ' uuid ');
    }
    columnHeaders = columnHeaders?.filter((data) => data !== '_uuid_');
    const htmlData = (
      <>
        <Table celled className={disable ? 'component-isDisabled' : ''}>
          <Table.Header>
            <Table.Row>
              {columnHeaders?.map((header: string) => {
                return (
                  <Table.HeaderCell>
                    {header?.split('_')?.join(' ')}
                  </Table.HeaderCell>
                );
              })}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {tempValue?.map((tableRowData: any) => {
              return (
                <Table.Row>
                  {columnHeaders?.map((header: string) => {
                    return <Table.Cell>{tableRowData[header]}</Table.Cell>;
                  })}
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </>
    );
    return htmlData;
  };

  const handleItemDelete = () => {
    setOpenItemDeleteModal({
      id: '',
      name: '',
    });
    modalStore.closeModal();
    setTimeout(() => {
      refreshHandler();
    }, 300);
  };

  return (
    <div
      style={style}
      // style={flexBasis?.charAt(0) !== '0' ? styleHandler(flexBasis) : undefined}
      className="new-report-table-wrapper"
    >
      {isCarouselModalOpen && (
        <CarouselLib
          images={photos}
          closeHandler={() => setIsCarouselModalOpen(false)}
        />
      )}
      {isModalOpen && (
        <DeleteModal
          text="Are you sure you want to delete this?"
          closeHandler={() => setIsModalOpen(false)}
          deleteHandler={deleteHandler}
          isModalOpen={isModalOpen}
        />
      )}
      {openItemDeleteModal.id !== '' && (
        <>
          {modalStore.openModal(
            <DeleteConfirmation
              type="dashboard"
              name={openItemDeleteModal.name}
              data={{
                id: openItemDeleteModal.id,
                title: openItemDeleteModal.name,
              }}
              updateHandler={handleItemDelete}
            />,
          )}
        </>
      )}
      <div
        className={loader.content ? 'icon-loading' : ''}
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <h4 style={{ color: '#3184d5' }}>{name || tableName}</h4>
        {downloadBtnMode !== 2 && (
          <Button
            style={{
              margin: '0px 10px 0px auto',
              height: 'fit-content',
              padding: '3px',
              background: 'transparent',
              width: '22px',
            }}
            disabled={downloadBtnMode === 0}
          >
            <CSVLink data={tableDownloadHandler()}>
              <Icon color="grey" name="download" />
            </CSVLink>
          </Button>
        )}
        <Icon
          name="refresh"
          color="grey"
          style={{ cursor: 'pointer' }}
          onClick={refreshHandler}
        />
      </div>
      <div
        style={{
          overflow: 'auto',
          maxHeight: '70vh',
          minHeight: masterId === static_items_id ? '400px' : '',
        }}
      >
        <Table sortable selectable celled singleLine>
          <Table.Header>
            <Table.Row>
              {tableHeaderDetails?.map((data, index) =>
                // commonStore.staticRegisterDemoChanges &&
                // ((DynamicDashboardStore.staticSelectedCard.includes(
                //   'Register & Payment',
                // ) &&
                //   name === 'Report' &&
                //   ((data.name || data).includes('Approval') ||
                //     (data.name || data).includes(
                //       'Course Payment Transaction No',
                //     ))) ||
                //   (DynamicDashboardStore.staticSelectedCard.includes(
                //     'Approval',
                //   ) &&
                //     name === 'Report' &&
                //     (data.name || data).includes(
                //       'Course Payment Transaction No',
                //     ))) ? (
                //   <></>
                // ) :
                (data.name || data) !== 'assetId' ? (
                  <Table.HeaderCell
                    key={index}
                    sorted={
                      !!sortedNames.current[`${data.name || data}`]?.length
                        ? sortedNames.current[`${data.name || data}`] ===
                          'ascending'
                          ? 'descending'
                          : 'ascending'
                        : undefined
                    }
                    // onClick={() => dispatch({ type: "CHANGE_SORT", column: "name" })}
                  >
                    {masterId === static_items_id
                      ? data
                          .replaceAll(/_/g, ' ')
                          .replaceAll(
                            /\w\S*/g,
                            (txt: any) =>
                              txt.charAt(0).toUpperCase() +
                              txt.substr(1).toLowerCase(),
                          )
                      : data.name || data}
                    {/* {data.name || data} */}
                  </Table.HeaderCell>
                ) : (
                  <Table.HeaderCell></Table.HeaderCell>
                ),
              )}
            </Table.Row>
            <Table.Row>
              {tableHeaderDetails?.map((data, index) =>
                (data.name || data) !== 'assetId' ? (
                  <Table.HeaderCell
                    key={index}
                    // onClick={() => dispatch({ type: "CHANGE_SORT", column: "name" })}
                  >
                    {masterId !== static_items_id ? (
                      <Input
                        autoComplete={'on'}
                        style={{ minWidth: '200px' }}
                        name={data.name || data}
                        key={index}
                        fluid
                        value={
                          (searchDetails as any)?.[`${data.name || data}`] || ''
                        }
                        loading={
                          !!(searchDetails as any)?.[`${data.name || data}`]
                            ?.loading
                        }
                        icon={
                          !(searchDetails as any)?.[`${data.name || data}`]
                            ?.loading
                            ? 'search'
                            : undefined
                        }
                        placeholder={'Search...'}
                        onChange={(_e, { value }) => {
                          let copy = structuredClone(searchDetails);
                          if (
                            (copy as any)?.[`${data.name || data}`] &&
                            value?.length === 0
                          ) {
                            delete (copy as any)[`${data.name || data}`];
                          } else {
                            (copy as any)[`${data.name || data}`] = value;
                          }
                          setSearchDetails(copy);
                        }}
                      />
                    ) : (
                      <Select
                        key={index}
                        fluid
                        filter
                        Selection
                        search
                        // upward={false}
                        clearable
                        options={itemsSearchList[data]}
                        onChange={(_e: any, dd: any) => {
                          let copy = structuredClone(searchDetails);
                          if (
                            (copy as any)?.[`${data.name || data}`] &&
                            dd?.value?.length === 0
                          ) {
                            delete (copy as any)[`${data.name || data}`];
                          } else {
                            (copy as any)[`${data.name || data}`] = dd.value;
                          }
                          setSearchDetails(copy);
                        }}
                        value={
                          assetType !== undefined &&
                          assetType !== '' &&
                          data === 'type'
                            ? assetType
                            : elementType !== undefined &&
                                elementType !== '' &&
                                data === 'element'
                              ? elementType
                              : (searchDetails as any)?.[
                                  `${data.name || data}`
                                ] || ''
                        }
                        placeholder={`Search ${data}`}
                        disabled={
                          (assetType !== undefined &&
                            assetType !== '' &&
                            data === 'type') ||
                          (elementType !== undefined &&
                            elementType !== '' &&
                            data === 'element')
                        }
                      />
                    )}
                  </Table.HeaderCell>
                ) : index === 0 ? (
                  <Table.HeaderCell width={1}></Table.HeaderCell>
                ) : (
                  <></>
                ),
              )}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {tableDetails.map((data, index) => (
              <Table.Row
                key={index}
                onClick={() => rowClickHandler?.(data)}
                style={
                  rowSelectedId === data.assetId
                    ? { backgroundColor: '#f2f2f2', cursor: 'pointer' }
                    : { cursor: 'pointer' }
                }
              >
                {!commonStore.filterModeTwo?.includes(data.templateElementId) &&
                  masterId !== static_worklevel_id && (
                    <Table.Cell
                      disabled={commonStore.filterModeZero?.includes(
                        data.templateElementId,
                      )}
                    >
                      <Button.Group
                        style={{
                          width: '100%',
                          maxWidth: '120px',
                        }}
                      >
                        {editBtnMode !== 2 && (
                          <Button
                            disabled={
                              editBtnMode === 0 ||
                              deleteDetails.loading ||
                              !HandleEditAndDelete?.(data)
                            }
                            icon="edit"
                            onClick={() =>
                              editHandler(
                                data.assetId,
                                masterId === static_items_id ? data?.Id : '',
                              )
                            }
                          />
                        )}
                        {editBtnMode !== 2 && deleteBtnMode !== 2 && (
                          <Button.Or />
                        )}
                        {deleteBtnMode !== 2 && (
                          <>
                            <Button
                              disabled={
                                deleteBtnMode === 0 ||
                                !HandleEditAndDelete?.(data)
                              }
                              icon="trash"
                              positive
                              onClick={() => {
                                if (masterId !== static_items_id) {
                                  setDeleteDetails({
                                    assetId: data.assetId,
                                    loading: false,
                                  });
                                  setIsModalOpen(true);
                                } else {
                                  setOpenItemDeleteModal({
                                    id: data.Id,
                                    name: data.Title,
                                  });
                                }
                              }}
                            />
                          </>
                        )}
                      </Button.Group>
                    </Table.Cell>
                  )}
                {Object.entries(data).map(
                  ([key, value]: any) =>
                    key !== 'assetId' &&
                    !commonStore.filterModeTwo?.includes(
                      data.templateElementId,
                    ) &&
                    (!(
                      masterId === static_items_id &&
                      (key === 'Id' ||
                        (!itemsPayload?.includes('Title') &&
                          key === 'Title' &&
                          metaData?.length > 0))
                    ) ? (
                      <Table.Cell
                        disabled={commonStore.filterModeZero?.includes(
                          data.templateElementId,
                        )}
                        key={key}
                        style={{
                          color:
                            tableHeaderDetails.flatMap((data) =>
                              (data.name || data) === key
                                ? data.mode === 0
                                : [],
                            )?.[0] && 'grey',
                        }}
                      >
                        {/Photos\|/.test(value) ? (
                          <div
                            className="photo-cell"
                            onClick={() => {
                              setPhotos(
                                value?.split('|')?.[1]?.split(',') || [],
                              );
                              setIsCarouselModalOpen(true);
                            }}
                          >
                            <img
                              src={
                                value?.split('|')?.[1]?.split(',')?.[0] ||
                                'https://picsum.photos/200'
                              }
                              alt=""
                            />
                            {value?.split(',').length - 1 > 0 && (
                              <span>
                                <Icon color="black" name="add" />
                                {value?.split(',').length - 1 > 9
                                  ? 9
                                  : value?.split(',').length - 1}
                              </span>
                            )}
                          </div>
                        ) : /DynamicTable\|/.test(value) ? (
                          <div>
                            {displayGridData(
                              value,
                              tableHeaderDetails.flatMap((data) =>
                                (data.name || data) === key
                                  ? data.mode === 0
                                  : [],
                              )?.[0],
                            )}
                          </div>
                        ) : value?.includes('//') ? (
                          <Link to={`/mediaAssets/${value?.split('//')[1]}`}>
                            {value?.split('//')[0] || ''}
                          </Link>
                        ) : masterId === static_items_id && key === 'Title' ? (
                          <Link to={`/mediaAssets/${data.Id}`}>
                            {value || ''}
                          </Link>
                        ) : (
                          value || ' '
                        )}
                      </Table.Cell>
                    ) : (
                      <></>
                    )),
                )}
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      {!isCriteria && (
        <Pagination
          activePage={activePage}
          ellipsisItem={{
            content: <Icon name="ellipsis horizontal" />,
            icon: true,
          }}
          firstItem={{
            content: <Icon name="angle double left" />,
            icon: true,
          }}
          lastItem={{
            content: <Icon name="angle double right" />,
            icon: true,
          }}
          prevItem={{ content: <Icon name="angle left" />, icon: true }}
          nextItem={{ content: <Icon name="angle right" />, icon: true }}
          totalPages={Math.ceil(count / pageSize)}
          onPageChange={onPageChangeHandler}
        />
      )}
    </div>
  );
}

export default TableReport;
